import React, { Component, Fragment } from "react";
import MetasMensais from "../../../Components/Educacao/MetasMensais"

export default class PageMetasMensais extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas"
        }
    }

    render() {
        return(
            <Fragment>
                <MetasMensais idmeta={this.props.match.params._id} unidade={this.props.match.params.unidade}/>
            </Fragment>
        )
    }
}